import { useIsExperimentsReady } from '@seek/candidate-feature-flag';
import { useEffect } from 'react';

import useAuthenticated from 'src/hooks/useAuthenticated';
import { useAnalyticsFacade } from 'src/modules/AnalyticsFacade';

export const useHomeTracking = () => {
  const analyticsFacade = useAnalyticsFacade();
  const isExperimentsReady = useIsExperimentsReady();
  const authStatus = useAuthenticated();

  useEffect(() => {
    if (isExperimentsReady && authStatus !== 'pending') {
      // Force next tick to allow the auth data to be available in the data layer
      setTimeout(() => {
        analyticsFacade.homePageLoaded({ flightId: undefined });
      });
    }
  }, [analyticsFacade, authStatus, isExperimentsReady]);
};
